import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from "gatsby-image"
// Create a GraphQL query for the comment list.

const dictionary = require("../dic/dic.json");
// Main component class.


function BannerPost({content}){
  return (
        <div dangerouslySetInnerHTML={{ __html: content }} />
  );
}

export default BannerPost;
